import { Page, Text, View, Document, StyleSheet, PDFDownloadLink, pdf, Image } from '@react-pdf/renderer';

import { FilterDefinition, SelectedFilter } from '../api/dashboard';
import { assetBase } from '../config';

const img = (name: string) => `${assetBase}/img/${name}`;

export interface DocumentProps {
  geoUri: string,
  yearsUri: string,
  disciplinesUri: string,
  incidentTypesUri: string,
  filterDefinitions: FilterDefinition[] | null,
  selected: SelectedFilter[];
  fatalities: number

}
interface FilterHeaderProps {
  selected: SelectedFilter[],
  filterDefinitions: FilterDefinition[] | null
}
interface FooterProps {
  date: Date
}
interface ChartProps {
  title: string,
  srcUri: string

}
const Footer = ({ date }: FooterProps) => {
  return (<View style={{ bottom: 50, position: 'absolute', textAlign: 'center', flexDirection: 'column', alignItems: 'center' }}>
    <Text style={{fontSize:16, fontWeight: 'bold'}}>Report Date: {date.toLocaleDateString('en-US')}</Text>
    <View style={{ marginTop: 10, textAlign: 'center', flexDirection: 'column', alignItems: 'center' }}>
      <Text style={{ fontSize: 10, textAlign: 'center', fontWeight:'bold' }}>Prepared by</Text>
      <Image src={img("RS_Logo_Blue.png")} style={{ width: 100, marginTop: 5 }} />
      <Text style={{ fontSize: 10, marginTop: 10, fontWeight:'bold' }}>Struck-By Incident Reports Data</Text>
    </View>
  </View>);
}
const Chart = ({ title, srcUri }: ChartProps) => {
  return (
    <View style={{ marginTop: 20, alignItems: 'center', marginLeft: 20, marginRight: 20 }}>
      <Text style={{ fontWeight: 'bold' }}>{title}</Text>
      <Image src={srcUri} style={{marginTop:10}} />
    </View>
  );
}
const FilterList = ({ selected, filterDefinitions }: FilterHeaderProps) => {
  if (selected.length == 0 || selected.find(s=>s.value != '') == null) {
    return null;
  }
  const definitions = filterDefinitions?.slice();
  //Start Date and End Date are not part of the filter definitions. Manually add.
  definitions?.push({ id: "StartDate", name: "Start Date", values: [] });
  definitions?.push({ id: "EndDate", name: "End Date", values: [] });
  return (
    <View style={{ marginBottom: 50,  width: '100%'}}>
      <Text style={{fontWeight: 'bold', fontSize:20, color: '#ffffff', marginLeft:20, marginRight: 20, backgroundColor: '#0c539a', paddingTop:5, paddingBottom:5 }}>Filters Applied:</Text>
      {definitions?.map(function (item, index) {
        const s = selected?.find(i => i.name == item.id);
        if (s == null) {
          return null;
        }
        let value = s.value;
        if (item.id.endsWith("Date")) {
          //If it's a date, reformat to LocaleDateString
          value = new Date(value).toLocaleDateString("en-US", { timeZone: 'UTC', });
        }
        return (<Text style={{ marginTop: 10, fontSize:14, marginLeft:20, marginRight: 20 }} wrap={true} key={item.id}>
          <Text style={{ fontWeight: 'bold' }} wrap={true}>{item.name}: </Text>
          <Text style={{ color: '#0c539a' }}>{value}</Text>
        </Text>);
      }
      )}
    </View>
  );
};

export const DocumentPdf = ({ geoUri, yearsUri, disciplinesUri, incidentTypesUri, selected, filterDefinitions, fatalities }: DocumentProps) => {
  const datetime = new Date();
  return (
    <Document>
      <Page style={{ textAlign: 'center', marginTop: 20, marginBottom: 20, alignContent: 'center', display: 'flex', alignItems: 'center', position: 'relative' }}>
        <Text style={{ fontSize: 30, fontWeight: 'bold' }} >Struck-By Incident Reports Data</Text>
        <Text style={{ marginTop: 50, fontWeight: 'bold', fontSize:16 }} >Brought to you by</Text>
        <Image src={img("RS_Logo_Blue.png")} style={{ width: 200, marginTop: 10 }} />
        <Image src={img("ERSI.png")} style={{ width: 80, marginTop: 10 }} />
        <Text style={{ marginTop: 50, fontWeight:'bold', fontSize:16 }} >Supported by</Text>
        <Image src={img("CVVFA_Logo_Black.png")} style={{ width: 100, height: 106, marginTop: 20 }} />
        <Text style={{ fontSize: 12, marginTop: 50, marginLeft: 20, marginRight: 20 }}>This report and its content were created by the CVVFA/Emergency Responder Safety Institute.</Text>
        <Text style={{ marginTop: 30, fontWeight: 'bold' }}>Report Date: {datetime.toLocaleDateString('en-US')}</Text>
        

        <View style={{ bottom: 50, position: 'absolute', textAlign: 'center', flexDirection: 'column', alignItems: 'center' }}>
          <Text style={{ fontSize: 10, textAlign: 'center', fontWeight:'bold' }}>Prepared by</Text>
          <Image src={img("RS_Logo_Blue.png")} style={{ width: 100, marginTop: 5 }} />
          <Text style={{ fontSize: 10, marginTop: 10, fontWeight:'bold' }}>Struck-By Incident Reports Data</Text>
        </View>
      </Page>
      <Page style={{ marginTop: 20, marginBottom: 20, position: 'relative',alignItems: 'center' }}>
        <FilterList selected={selected} filterDefinitions={filterDefinitions} />
        <View style={{ maxWidth: '100%', marginLeft: 20, marginRight: 20 }} >
          <Text style={{ fontWeight: 'bold', fontSize:14 }}>Report Parameters</Text>
          <Text style={{ fontSize: 12 }}>
            The Emergency Responder Safety Institute (ERSI), a committee of the Cumberland Valley Volunteer Firefighters Association (CVVFA), maintains the only national database of reports of struck-by incidents that occur when a responder or an emergency vehicle is hit while operating at a roadway incident. All responders from all disciplines are encouraged to report any struck-by incident they are aware of. All reports are vetted before they are released into the data set for analysis. This report was output from the ReportStruckBy.com database on the date indicated on the title page and with the filters applied to the dataset (if any) as listed on the title page
          </Text>
        </View>
        <View style={{ maxWidth: '100%', marginLeft: 20, marginRight: 20, marginTop: 30 }} >
          <Text style={{ fontWeight: 'bold', fontSize:14 }}>Disclaimer</Text>
          <Text style={{ fontSize: 12 }}>
            The dataset is of voluntary reports from the field and may not include all struck-by line-of-duty deaths or all struck-by incidents. The ERSI tracks LODD struck-by fatalities manually; please visit the ResponderSafety.com Yearly Fatality Reports page for information on all known struck-by LODDs since 2019. A map of struck-by LODDs is also available.
          </Text>
        </View>
        <Footer date={datetime} />

      </Page>
      <Page style={{ marginTop: 20, marginBottom: 20, position: 'relative', display: 'flex', alignItems: 'center', }}>
        <Text style={{ fontWeight: 'bold' }}>Struck by Fatalities: {fatalities}</Text>
        <Chart title="Fatalities by State" srcUri={geoUri} />
        <Chart title="Fatalities by Discipline" srcUri={disciplinesUri} />
        <Footer date={datetime} />
      </Page>
      <Page style={{ marginTop: 20, marginBottom: 20, position: 'relative', display: 'flex', alignItems: 'center', }}>
        <Chart title="Fatalities per Year" srcUri={yearsUri} />
        <Chart title="Fatalities During Response Activities" srcUri={incidentTypesUri} />
        <Footer date={datetime} />
      </Page>
    </Document>
  );
}